export default {
  SMS: "sms",
  MAIL: "mail"
};
